import { gql } from "@apollo/client";
import CommentFields from "~/lib/queries/fragments/CommentFields";

export default gql`
  mutation ReplyComment($replyTo: ObjectId!, $body: JSON!) {
    replyComment(replyTo: $replyTo, body: $body) {
      _id
      ...CommentFieldsLegacy
    }
  }

  ${CommentFields}
`;
